import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Category, Recipe } from '../../services/api/models';
import { Api } from '../../services/api';
import useRunOnce from '../../util/runOnce';
import { Control, Controller } from 'react-hook-form';
import { FormControl } from '@mui/material';
import idx from 'idx';

export interface CategorySelectorProps {
    label?: string
    control: Control<Recipe>
}

export default function CategorySelector(props: CategorySelectorProps) {
  const [open, setOpen] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState<readonly Category[]>([]);


  useRunOnce(() => {
    Api.Category.list()
      .then(response => {
        setCategoryOptions(response.data.results);
      }).catch(error => {
        console.warn(error);
      }).finally(() => {
      });
  });

  return (
    <Controller
      name='category'
      control={props.control}
      render={(rprops) => (
        <FormControl>
          <Autocomplete
            {...rprops}
            sx={{ width: 300 }}
            open={open}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            defaultValue={rprops.formState.defaultValues?.category}
            key={idx(rprops, _ => _.formState.defaultValues?.category?.id)}
            onChange={(_, item) => rprops.field.onChange(item)}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.name || ''}
            options={categoryOptions}
            renderInput={(params) => (
              <TextField
                helperText={rprops.fieldState.error?.message?.toString()}
                error={!!rprops.fieldState.error?.message}
                {...params}
                label={props.label}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </FormControl>
      )}
    />
  );
}
